module.exports = __webpack_public_path__ + "icon_plan-26bd840d05323ffcb2f879236340f481.png";